import React from 'react';
import PropTypes from 'prop-types';

class Modal extends React.Component{
    render(){
      return (
          <div className={`modal open`} onClick={this.props.onClose}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <span className="modal-close" onClick={this.props.onClose}>&times;</span>
                  <h3 className="dashboard-card__title-text modal-header">{this.props.title}</h3>
                  {this.props.children}
              </div>
          </div>
      )
    }
}

Modal.propTypes = {
    title: PropTypes.string,
    children: PropTypes.object,
    onClose: PropTypes.func
};

export default Modal;